import React from 'react';
import cx from 'classnames';

import FeaturedBaseView from './FeaturedBaseView';

const FeaturedH2CenterView = (props) => {
  return (
    <FeaturedBaseView
      {...props}
      centeredText={true}
      headerSize="small"
      animatedHeading={true}
      HeadingTag="h2"
      className={cx('featured-h2', props.className)}
      buttons="true"
    />
  );
};

export default FeaturedH2CenterView;
